__turbopack_context__.v({
  "folderSection": "FoldersLayout-module__KdTUeG__folderSection",
  "folderSections": "FoldersLayout-module__KdTUeG__folderSections",
  "myFolderTree": "FoldersLayout-module__KdTUeG__myFolderTree",
  "sharedFolderTree": "FoldersLayout-module__KdTUeG__sharedFolderTree",
});
